import * as React from "react";
import { FormComponent } from "../../../../../../../../react-core/Html/FormComponent";
import { Navigator } from "../../../../../../../Shared/Wizards/Entities/Navigator";
import { Urls } from "../../../../../../Urls";
import { AssetsToSellTable } from "./AssetsToSellTable";
import { BankDetails } from "./BankDetails";
import { PaymentDetails } from "./PaymentDetails";

interface IIncomePaymentDetailsProps {
    data: any;
    extraInfo?: any;
}

interface IIncomePaymentDetailsState {}

export class IncomePaymentDetails extends FormComponent<IIncomePaymentDetailsProps, IIncomePaymentDetailsState> {
    constructor(props: any) {
        super(props);
    }

    public render(): JSX.Element {
        const { data, extraInfo } = this.props;
        return (
            <>
                <div className="row narrow-gutter">
                    <h2 className="col-fluid heading-underlined mt-20">Income payment details</h2>
                    <div className="col-auto">
                        <button
                            className="edit-circle-icon-button label-sr-only"
                            title="Edit"
                            onClick={() => {
                                Navigator.navigateToAndPreserveQueryParameters(
                                    Urls.get().GadReviewIncomePaymentDetails
                                );
                            }}
                        >
                            <span className="icon" aria-hidden="true"></span>
                            <span className="text">Edit</span>
                        </button>
                    </div>
                </div>
                <PaymentDetails data={data} />
                <AssetsToSellTable
                    existingData={data?.DrawdownIncome?.IncomeDisinvestmentAllocations || []}
                    tableData={data?.DrawdownIncomeAmendmentInstruction?.Income?.IncomeDisinvestmentAllocations || []}
                />
                <BankDetails data={data} extraInfo={extraInfo?.AllBankAccounts} />
                <hr />
            </>
        );
    }
}
